import VectorTileLayer from "ol/layer/VectorTile";
import Style from "ol/style/Style";
import Stroke from "ol/style/Stroke";
import CircleStyle from "ol/style/Circle.js";
import RegularShape from "ol/style/RegularShape";
import VectorLayer from "ol/layer/Vector";
import Fill from "ol/style/Fill";
import { applyStyle } from "ol-mapbox-style";
import TileLayer from "ol/layer/Tile";
import { Group } from "ol/layer";
import { constants } from "./sources.js";

import { 
  source_planungstrasse,
  // source_pt_380,
  source_hinweise_overview,
  source_hinweise,
  source_grobtrasse,
  source_anschlusspunkte,
  source_demontage,
  source_uws,
  source_maststandorte,
  source_wegeplanung,
  source_variante,
  katasterSource,
  katasterSymboleSource,
  amapSource,
  orthoSource } from "./sources.js";

import { 
  planungstrasseStyleFunction, 
  uwStyleFunction, 
  dot_style_anschlusspunkte, 
  grobtrasseStyleFunction, 
  mastStandorteStyleFunction, 
  hinweiseStyleFunction,
  hinweiseOverviewStyleFunction
 } from "./styles.js";


// /////////////////////////
// Base layers
// /////////////////////////
const katasterLayer = new VectorTileLayer({
  layerId: "kataster",
  source: katasterSource,
  declutter: true,
});

const symboleLayer = new VectorTileLayer({
  layerId: "katasterSymbole",
  source: katasterSymboleSource,
  declutter: true,
});

// Mapbox-Stil laden:
applyStyle(katasterLayer, "data/kataster_vermv.json");
applyStyle(symboleLayer, "data/symbole_vermv.json");

export const katasterLayerGroup = new Group({
  layerId: "katasterGroup",
  layers: [katasterLayer, symboleLayer],
  opacity: 0.5,
});


export const amapLayer = new TileLayer({
  layerId: "karte",  
  source: amapSource,
  visible: false,
});

export const orthoLayer = new TileLayer({
    layerId: "ortho",
  source: orthoSource,
  visible: false,
});


// /////////////////////////
// Grobtrasse
// /////////////////////////
export const uwLayer = new VectorLayer({
  layerId: "uws",
  source: source_uws,
  style: uwStyleFunction,
});

export const anschlusspunkteLayer = new VectorLayer({
  layerId: "anschlusspunkte",
  source: source_anschlusspunkte,
  style: new Style({ image: dot_style_anschlusspunkte }),
});

const layerGT = (spannung) => {
  return new VectorLayer({ 
        layerId: `gt${spannung}`, 
        title: `Grobtrasse ${spannung}kv`,
        source: source_grobtrasse, 
        style: (feature, resolution) => grobtrasseStyleFunction(feature, resolution, spannung),
  });
};

export const gt380Layer = layerGT("380");
export const gt220Layer = layerGT("220");
export const gt110Layer = layerGT("110");


// /////////////////////////
// Planungstrasse
// /////////////////////////


export const hinweiseLayer = new Group({
  layerId: "hinweise",
  layers: [
    new VectorLayer({
      source: source_hinweise_overview,
      minResolution: 10,
      maxResolution: 100,
      style: hinweiseOverviewStyleFunction,
      zIndex: 20,
    }),
    new VectorLayer({
      source: source_hinweise,
      minResolution: 0,
      maxResolution: 10,
      style: hinweiseStyleFunction,
      zIndex: 21,
    }),
  ],
});







const layerGroupPT = (spannung) => {
  return new Group({
    layerId: `pt${spannung}`, 
    layers: [
      // ab hier detailansicht
      new VectorLayer({
        source: source_planungstrasse,
        style: (feature, resolution) => planungstrasseStyleFunction(feature, resolution, spannung, false),
        opacity: 0.5,
        zIndex: 3, // Vordergrund-Layer hat einen höheren zIndex
      }),
      new VectorLayer({ 
        source: source_planungstrasse,
        style: (feature, resolution) => planungstrasseStyleFunction(feature, resolution, spannung, true),
        opacity: 0.5,
        zIndex: 2, // Hintergrund-Layer hat einen niedrigeren zIndex
      }),


      new VectorLayer({
        source: source_variante,
        layerId: 'ptvariante',
        style: (feature, resolution) => planungstrasseStyleFunction(feature, resolution, 'variante'),
        opacity: 0.5,
        zIndex: 4
      }),


      new VectorLayer({ 
        source: source_planungstrasse,
        style: (feature, resolution) =>  new Style({
          stroke: new Stroke({
            color: "grey",
            width: 2/resolution,
            offset: (constants.servitutsbreite/2+1)/resolution,
          }),
           zIndex: 1, // Hintergrund-Layer hat einen niedrigeren zIndex
        }),
      }),
      new VectorLayer({ 
        source: source_planungstrasse,
        style: (feature, resolution) =>  new Style({
          stroke: new Stroke({
            color: "grey",
            width: 2/resolution,
            offset: -(constants.servitutsbreite/2+1)/resolution,
          }),
           zIndex: 1, // Hintergrund-Layer hat einen niedrigeren zIndex
        }),
      }),
    ],
  });
};

export const pt380Layer = layerGroupPT("380");
export const pt220Layer = layerGroupPT("220");
export const pt110Layer = layerGroupPT("110");


export const mastStandorteLayer = new Group({
  layerId: "maststandorte",
  layers: [ 
    new VectorLayer({
      source: source_maststandorte,
      minResolution: 0 ,
      maxResolution: 10,
      style: (feature, resolution) => mastStandorteStyleFunction(feature, resolution, true),
      zIndex: 10, // Setze zIndex für die erste Ebene
    }),
    new VectorLayer({
      source: source_maststandorte,
      minResolution: 0,
      maxResolution: 20,
      style: (feature, resolution) => mastStandorteStyleFunction(feature, resolution, false),
      zIndex: 10, // Setze zIndex für die zweite Ebene
    })
  ],
});


export const wegeplanungLayer = new Group({
  layerId: "wegeplanung",
  layers: [
    new VectorLayer({
      source: source_wegeplanung,
      minResolution: 0,
      maxResolution: 10,
      style: new Style({
        stroke: new Stroke({
          color: "white",
          width: 5,
        }),
      }),
    }),
    new VectorLayer({
      source: source_wegeplanung,
      minResolution: 0,
      maxResolution: 10,
      style: new Style({
        stroke: new Stroke({
          color: "orange",
          width: 3,
        }),
      }),
    }),
  ],
});



// /////////////////////////
// Demontage
// /////////////////////////

export const demontageLayer = new VectorLayer({
  layerId: "demontageLayer",
  source: source_demontage,
  style: new Style({
    stroke: new Stroke({
      width: 5,
      color: "#66b2ff",
    }),
  }),
});

export const demontageBackgroundLayer = new VectorLayer({
  layerId: "demontageBackgroundLayer",
  source: source_demontage,
  style: new Style({
    stroke: new Stroke({
      width: 5,
      lineDash: [5, 10],
      lineCap: "butt",
      color: "#ffff00",
    }),
  }),
});


export const demontageLayerGroup = new Group({
  layerId: "demontageGroup",
  layers: [demontageLayer, demontageBackgroundLayer],
});


export const demontageMastGroup = new Group({
  layerId: "demontageMastGroup",
  layers: [
    new VectorLayer({
      layerId: "demontagemasten",
      source: source_maststandorte,
      minResolution: 0,
      maxResolution: 20,
      style: (feature, resolution) => {
        const planungsart = feature.get("planungsart");
        if (planungsart != "d") { return null; /* Keine Style anwenden, wenn die Planungsart nicht "d" ist */ }
        return new Style({
          image: new CircleStyle({
            radius: 5,
            fill: new Fill({ color: "yellow" }),
            stroke: new Stroke({ color: "black", width: 1 }),
          }),
        });
      },
    }),

    new VectorLayer({
      source: source_maststandorte,
      minResolution: 0,
      maxResolution: 20,
      style: (feature, resolution) => {
          const planungsart = feature.get("planungsart");
          if (planungsart != "d") { return null; /* Keine Style anwenden, wenn die Planungsart nicht "d" ist */ }
          return new Style({
          image: new RegularShape({
            fill: new Fill({ color: "red" }),
            stroke: new Stroke({ color: "black", width: 1 }),
            points: 4,
            radius: 5,
            radius2: 0,
            angle: Math.PI / 4,
          }),
        });
      },
    }),
  ],
});